import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Events from "../pages/events/page";
import EventDetail from "../pages/event-detail/page";
import Roundup from "../pages/roundup/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/events",
    element: <Events />,
  },
  {
    path: "/events/:slug",
    element: <EventDetail />,
  },
  {
    path: "/roundup",
    element: <Roundup />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;